module.exports = __webpack_public_path__ + "assets/img/trust.8458cd94.png";